const tourSteps = [
  {
    target: '.tour-logo',
    title: "Application Logo",
    content: "Click here to return to the dashboard.",
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: false,
    spotlightPadding: false,
  },
  {
    target: '.dashboard-module',
    title: "Dashboard Overview",
    content: "View all available modules along with their respective counts.",
    placement: 'bottom-start',
    disableBeacon: true,
    spotlightClicks: false,
    spotlightPadding: false,
     disableScrolling: true, 
  },
  {
  target: '.add-button',
  title: "Add New Record",
  content: "Click here to create and add a new record to the module.",
  placement: 'right',
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".email-filter",
  title: "Filter by Email",
  content: "Click here to filter data based on email classification.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".status-filter",
  title: "Filter by Email Status",
  content: "Click here to filter data based on the current email status.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".type-filter",
  title: "Email Type",
  content: "Click here to filter data based on email type.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".date-filter",
  title: "Filter by Date",
  content: "Click here to filter data based on the selected date.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: '.search-button',
  title: "Search Records",
  content: "Use this option to search and quickly find records.",
  placement: 'left',
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: '.export-data',
  title: "Export Data",
  content: "Use this option to export filtered data as a CSV file.",
  placement: 'left',
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: '.total-lead',
  title: "Total Leads",
  content: "View the total number of leads after applying filters.",
  placement: 'left',
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: '.table-data',
  title: "Data Table",
  content: "All records in this module are displayed here in a table.",
  placement: 'center',
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".view",
  title: "View Record",
  content: "Click here to view details of the selected record.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".edit",
  title: "Edit Record",
  content: "Click here to update or modify the selected record.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".delete",
  title: "Delete Record",
  content: "Click here to permanently remove the selected record.",
  placement: "bottom",
  disableBeacon: true,
  spotlightClicks: false,
  spotlightPadding: false,
  disableScrolling: true, 
},
{
  target: ".pdf",
  title: "View PDF",
  content: "Click here to view the record in PDF format."
},
  {
    target: ".pagination",
    title: "Pagination Controls",
    content: "Navigate through pages to view additional records.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
    spotlightPadding: false,
  },
  {
    target: ".logout",
    title: "Logout Controls",
    content: "You can Logout the admin Page.",
    placement: "bottom",
    disableBeacon: true,
    spotlightClicks: false,
    spotlightPadding: false,
  },
  
];

export default tourSteps;
